import "./Home.css";

const Home = () => {
    return (
        <div className="home-container">
            <div className="text-area">
                <h3 className="title">LIBERAL CHART とは</h3>
                <p>
                    金沢工業大学のリベラルアーツ系科目の早見表です。Headerの「免責事項」より、免責事項を必ずご確認の上でご利用ください。
                    このサイトは非公式のものであり、金沢工業大学とは一切関係ありません。
                    正規の情報は金沢工業大学のeシラバス又は、キャンパスガイドを参照してください。
                </p>
            </div>
        </div>
    );
}

export default Home;